import { useRef, useEffect } from 'react';

export default function useMultiClick(clickCount = 5, timeWindow = 2000) {
  const clicksRef = useRef(0);
  const timerRef = useRef(null);

  // Clean up timer on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return function (callback) {
    function handleClick() {
      // Increment click counter
      clicksRef.current += 1;

      // Reset existing timer
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      // If we've reached the target click count, execute callback
      if (clicksRef.current >= clickCount) {
        clicksRef.current = 0;
        callback();
        return;
      }

      // Start timer to reset clicks if time window expires
      timerRef.current = setTimeout(() => {
        clicksRef.current = 0;
      }, timeWindow);
    }

    return {
      onClick: handleClick,
      // We still include these to clean up the event handling
      onMouseLeave: () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
          clicksRef.current = 0;
        }
      },
    };
  };
}
